<template>
  <vs-popup class="holamundo asset-modal" :class="{'hide-metadata': !showMetadata}" title="View asset" :active.sync="popupActive">
    <div class="d-flex w-100" :class="{'asset3d-viewer-bg': item && item.asset_type === '3D' && !showMetadata}" style="flex-direction: column">
      <template v-if="!showMetadata">
        <video v-if="['animation', 'video'].includes(item.asset_type)" autoplay controls allowfullscreen="" frameborder="0" :src="getLink()"/>
        <img :src="getLink()" v-if="item && item.asset_type === 'image'" alt=""/>
      </template>
      <iframe :src="getLink()" :class="{'global-asset-iframe': !showMetadata}" width="100%" height="100%" v-if="item && item.asset_type === '3D' || showMetadata"></iframe>
      <div class="asset-modal-link" v-if="withLink && showMetadata">
        <vs-input readonly :value="`${origin}/${id || item && item.asset_object_id}`"/>
      </div>
    </div>
  </vs-popup>
</template>

<script>

export default {
  props: {
    id: {type: String, default: null},
    item: {type: Object, default: null},
    locale: String,
    noEdit: {type: Boolean, default: false},
    withLink: {
      type: Boolean,
      default: false
    },
    formatReference: {
      type: String,
      default: null
    },
    showMetadata: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      bodyOverflow: "",
      popupActive: true,
      isAction: false,
      origin: location.origin
    }
  },
  computed: {},
  mounted() {
    this.popupActive = true;
    this.bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  },
  created() {

  },
  destroyed() {
    document.body.style.overflow = this.bodyOverflow;
  },
  watch: {
    popupActive() {
      if (!this.popupActive) {
        this.closeModal();
      }
    }
  },
  methods: {
    closeModal() {
      setTimeout(() => {
        this.$emit('closeModal', this.isAction);
      }, 1)
    },
    getLink() {
      if (this.showMetadata) {
        return `/${this.id || this.item && this.item.asset_object_id}?locale=${this.locale}${this.noEdit ? '&no-edit=true' : ''}${this.formatReference ? `&formatReference=${this.formatReference}` : ''}`
      } else {
        if (this.item.asset_type === '3D') {
          const iframeUrl = `https://coobo-cdn.embibe.com/teach_lite_3d_viewer_test/lite.html`
          return `${iframeUrl}?id=asset-${this.item.variants_data.coobo_library_link.split('/').pop()}`
        } else if (this.item.asset_type === 'image') {
          let readyLink = this.item.variants_data.ready_links.find(link => link.mime.match(/image/gi));

          return readyLink.url || '';
        } else if (["animation", "video"].includes(this.item.asset_type)) {
          let readyLink = this.item.variants_data.ready_links.find(link => link.mime.match(/video/gi));

          return readyLink.url || '';
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.asset3d-viewer-bg {
  background-image: linear-gradient(135deg, #2a2399, #098cf1);
}

</style>
